import React from 'react';
import { Table, Button, Popup } from 'semantic-ui-react';
import MobilityDetails from '../../StudentService/StudentOverview/MobilityDetails';
import { Link } from 'react-router-dom';
import EditProperty from './Details/EditProperty';


const PropertyList = ({
    allOrganizationalUnitProperties, activateEditRequest, activateDetailsRequest
}) => (
    <Table celled selectable sortable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell >Organizaciona jedinica</Table.HeaderCell>
                <Table.HeaderCell >Naziv imovine</Table.HeaderCell>
                <Table.HeaderCell >Tip prava</Table.HeaderCell>
                <Table.HeaderCell >Status</Table.HeaderCell>

                <Table.HeaderCell></Table.HeaderCell>

            </Table.Row>
        </Table.Header>

        <Table.Body>
            {allOrganizationalUnitProperties.reverse().map(el =>
                (
                    <Table.Row key={el.id}>
                        <Table.Cell >{el.organizationalUnit.name}</Table.Cell>
                        <Table.Cell >{el.property.name}</Table.Cell>
                        <Table.Cell >{el.rightType.name}</Table.Cell>
                        <Table.Cell >{el.active ? 'aktivna' : 'arhivirana/neaktivna/pasivna'}</Table.Cell>

                        <Table.Cell verticalAlign="middle" className="text-center" >

                            <Popup
                                content="Detalji"
                                position="top center"
                                trigger={

                                    <Button
                                        basic="true"
                                        circular
                                        icon="align justify"
                                        size="tiny"
                                        color="blue"
                                        onClick={() => {
                                            localStorage.setItem('orgUnitProperty', JSON.stringify(el));
                                            activateDetailsRequest();
                                        }}
                                    />

                                }
                            />
                            <Popup
                                content="Izmjena"
                                position="top center"
                                trigger={

                                    <Button
                                        basic="true"
                                        circular
                                        icon="pencil"
                                        size="tiny"
                                        color="green"
                                        onClick={() => {
                                            localStorage.setItem('orgUnitProperty', JSON.stringify(el));
                                            activateEditRequest();
                                        }}
                                    />

                                }
                            />
                            <Popup
                                content="Brisanje"
                                position="top center"
                                trigger={

                                    <Button
                                        basic="true"
                                        circular
                                        disabled
                                        icon="close"
                                        size="tiny"
                                        color="red"
                                        onClick={() => {

                                        }}
                                    />

                                }
                            />
                            {/* <Button */}
                            {/*    basic */}
                            {/*    color="blue" */}
                            {/*    size="small" */}
                            {/*    onClick={() => { */}
                            {/*        localStorage.setItem('property', JSON.stringify(el)); */}
                            {/*        activateEditRequest(); */}
                            {/*    }} */}
                            {/* > */}
                            {/*    Izmjena */}
                            {/* </Button> */}
                            {/* <Button */}
                            {/*    basic */}
                            {/*    color="blue" */}
                            {/*    size="small" */}
                            {/*    onClick={() => { */}
                            {/*        localStorage.setItem('property', JSON.stringify(el)); */}
                            {/*        activateDetailsRequest(); */}
                            {/*    }} */}
                            {/* > */}
                            {/*    Detalji */}
                            {/* </Button> */}

                        </Table.Cell>

                    </Table.Row>
                ))
            }
        </Table.Body>
    </Table>
);

export default PropertyList;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/PropertyList.js